import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../../../../component/ui/Button';

import { hasPermission } from '../../../../../utils/controller';
import { useSelector } from 'react-redux';

const CreateInvoiceHeader = ({
	setIsInvoiceAutoSave,
	setIsAllowPasswordUpdateInvoice,
	setIsSaveWithEmail,
	setSaveAsDraft,
	handleSubmitInvoice,
	deleteInvoice,
	isDraft,
	loading,
}) => {
	const navigate = useNavigate();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;
	// const [loading, setLoading] = useState({
	// 	isLoading: false,
	// 	status: null,
	// 	isSendEmail: false,
	// });
	// const [isNextLocation, setIsNextLocation] = useState(null);
	// const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	// const [isInvoiceAutoSave, setIsInvoiceAutoSave] = useState(false);
	// const [isSaveWIthEmail, setIisSaveWIthEmail] = useState(false);
	// const [saveAsDraft, setSaveAsDraft] = useState(false);
	// const [editInvoicePassword, setEditInvoicePassword] = useState('');
	// const [errorPassword, setErrorPassword] = useState('');
	// const [isAllowPasswordUpdateInvoice, setIsAllowPasswordUpdateInvoice] = useState(false);

	return (
		<div className="product-pg-header add-product header-position-sticky">
			<p>
				{id ? 'Update ' : 'Create New '}
				Invoice
			</p>
			<div className="add-product-button">
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button="Save"
					loader={loading?.status === 1 && loading.isLoading && !loading.isSendEmail}
					disabled={
						(loading?.status === 1 && loading.isLoading && !loading.isSendEmail) ||
						(id
							? !hasPermission('sales.invoices.edit', user?.role?.role_permissions)
							: !hasPermission('sales.invoices.create', user?.role?.role_permissions))
					}
					onClick={() => {
						if (
							id &&
							!id.includes('id') &&
							user?.settings?.sales?.allow_editing_sales_invoice?.value
						) {
							setIsInvoiceAutoSave(false);
							setIsAllowPasswordUpdateInvoice(true);
							setIsSaveWithEmail(false);
							setSaveAsDraft(false);
						} else {
							setIsInvoiceAutoSave(false);
							handleSubmitInvoice(1);
						}
					}}
				/>
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button="Save and Send"
					loader={loading?.status === 1 && loading.isLoading && loading.isSendEmail}
					disabled={
						(loading?.status === 1 && loading.isLoading && loading.isSendEmail) ||
						!hasPermission('sales.invoices.communications_email', user?.role?.role_permissions)
					}
					onClick={() => {
						if (
							id &&
							!id.includes('id') &&
							!user?.settings?.sales?.allow_editing_sales_invoice?.value
						) {
							setIsInvoiceAutoSave(false);
							setIsAllowPasswordUpdateInvoice(true);
							setIsSaveWithEmail(true);
							setSaveAsDraft(false);
						} else {
							setIsInvoiceAutoSave(false);
							handleSubmitInvoice(1, true);
						}
					}}
				/>
				{!id || (id && isDraft) ? (
					<Button
						type="button"
						className="btn-primary mt-0 px-4"
						button="Save as Draft"
						loader={loading?.status === 0 && loading.isLoading}
						disabled={
							(loading?.status === 0 && loading.isLoading) ||
							(id
								? !hasPermission('sales.invoices.edit', user?.role?.role_permissions)
								: !hasPermission('sales.invoices.create', user?.role?.role_permissions))
						}
						onClick={() => {
							if (
								id &&
								!id.includes('id') &&
								user?.settings?.sales?.allow_editing_sales_invoice?.value
							) {
								setIsInvoiceAutoSave(false);
								setIsAllowPasswordUpdateInvoice(true);
								setIsSaveWithEmail(false);
								setSaveAsDraft(true);
							} else {
								setIsInvoiceAutoSave(false);
								handleSubmitInvoice(0);
							}
						}}
					/>
				) : (
					<></>
				)}
				<Button
					type="button"
					className="mt-0 btn-danger add-pro"
					button=""
					close
					onClick={() => {
						if (id && !id.includes('id')) {
							deleteInvoice();
						}
						navigate(`/user/${suburl}/invoices`);
					}}
				/>
			</div>
		</div>
	);
};
export default CreateInvoiceHeader;
